<template>
  <el-container>
    <el-header style="height: 100%;">
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <el-row style="margin-bottom: 20px;">
        <span>以下任意一种方式通知考生参加考试</span>
      </el-row>
      <el-row style="margin-bottom: 10px;">
        <span>1、复制考试链接发给考生，打开链接参加考试</span>
      </el-row>
      <el-row>
        <el-input v-model="pcUrl" title="考试地址" style="width:450px" readonly></el-input>
        <el-button class="copyUrl but" type="primary" :data-clipboard-text="pcUrl" @click="copyUrl">复制</el-button>
        <el-button type="primary" @click="detail" class="but">打开</el-button>
      </el-row>
      <el-row style="margin-top: 20px; margin-bottom: 10px;">
        <span>2、将二维码发给考生，扫描参加考试</span>
      </el-row>
      <el-row>
        <vue-qr ref="Qrcode" :text="codeValue" :margin="10" :size="200" :dotScale="0.9" style="vertical-align: middle; margin-right: 10px"></vue-qr>
        <el-button type="primary" @click="downloadImg">微信二维码下载</el-button>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
// 导入组件
import vueQr from 'vue-qr'
import Clipboard from 'clipboard'
import { baseURL } from '../../assets/js/config.js'
import myHeader from '@/components/myHeader'
export default {
  name: 'preview',
  data () {
    return {
      // 路由地址
      path: '',
      // pc地址
      pcUrl: '',
      // 生成微信地址
      codeValue: ''
    }
  },
  components: {
    myHeader,
    vueQr
  },
  created () {
    const zt = this.$route.query.zt
    if (zt === '0') {
      this.$message.warning('注意：当前考试还未发布~')
    }
    const ksid = this.$route.query.ksid
    // this.path = '/exam/detail.html?ksid=' + ksid
    // const url = window.location.protocol + '//' + window.location.host
    // this.pcUrl = url + this.path
    this.pcUrl = baseURL + '/index.html/#/exam/baseInfo?ksid=' + ksid
    // this.codeValue = baseURL + '/wechat/examCallback?ksid=' + ksid
    this.codeValue = baseURL + '/index.html/#/exam/baseInfo?ksid=' + ksid
  },
  methods: {
    // 复制链接
    copyUrl () {
      var clipboard = new Clipboard('.copyUrl')
      clipboard.on('success', e => {
        console.log('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    // 打开详情
    detail () {
      /*
      const preview = this.$router.resolve({
        path: this.path
      })
      */
      // window.open(preview.href, '_blank')
      window.open(this.pcUrl, '_blank')
    },
    // 下载二维码图片
    downloadImg () {
      const imgUrl = this.$refs.Qrcode.$el.src
      const a = document.createElement('a')
      const event = new MouseEvent('click')
      const ksmc = this.$route.query.ksmc
      a.download = ksmc + '---二维码'
      a.href = imgUrl
      a.dispatchEvent(event)
    }
  }
}
</script>

<style scoped>

  .el-main{
    margin-top: 60px;
  }
  .but {
    margin-left: 10px
  }
</style>
